var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReset = function SvgReset(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 64.03a42.92 42.92 0 0 1-32.73 41.72 43.03 43.03 0 0 1-48.4-21.81 42.83 42.83 0 0 1 9.76-52.08 43.07 43.07 0 0 1 53.02-2.92l-.52-1.52a4.9 4.9 0 0 1 9.32-3.05l4.77 14.3a4.76 4.76 0 0 1-.67 4.29 4.78 4.78 0 0 1-4.1 2H83.1a4.77 4.77 0 0 1-4.78-4.77 4.77 4.77 0 0 1 3.4-4.48 33.5 33.5 0 0 0-40.74 4.09 33.31 33.31 0 0 0-6.24 40.38 33.47 33.47 0 0 0 37.61 16.14 33.38 33.38 0 0 0 25.08-32.3 4.77 4.77 0 0 1 9.56 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export default ForwardRef;